import { NgFor } from '@angular/common';
import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { CarouselModule, OwlOptions } from 'ngx-owl-carousel-o';
import { PersonasBookingComponent } from '../../personas/booking/booking.component';

@Component({
  selector: 'app-homepage',
  standalone: true,
  imports: [
    NgFor,
    CarouselModule,
    RouterLink,
    PersonasBookingComponent
  ],
  templateUrl: './homepage.component.html',
  styleUrl: './homepage.component.scss'
})
export class HomepageComponent {
  categories = [
    {
      id: 'restaurants',
      label: 'Restaurants',
      route: '/about/food/restaurants'
    },
    {
      id: 'lodging',
      label: 'Lodging',
      route: '/plan/accommodations'
    },
    {
      id: 'entertainment',
      label: 'Entertainment',
      route: '/about/activities/entertainment'
    },
    {
      id: 'sightseeing',
      label: 'Sightseeing',
      route: '/about/tours'
    },
    {
      id: 'transportation',
      label: 'Transportation',
      route: '/plan/travel'
    },
    {
      id: 'ground_transport',
      label: 'Ground Transportation',
      route: '/plan/transportation'
    }
  ];
  carouselOptions: OwlOptions = {
    autoWidth: true,
    loop: false,
    mouseDrag: false,
    touchDrag: false,
    pullDrag: false,
    dots: false,
    navSpeed: 700,
    navText: ['', ''],
    responsive: {
      0: {
        items: 1
      },
      400: {
        items: 2
      },
      740: {
        items: 3
      },
      940: {
        items: 4
      }
    },
    nav: true
  }
}
